module.exports = __webpack_public_path__ + "img/t4-purple.7f524ab1.png";